/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app.component.css.ngstyle.js.pre-build-optimizer.js